<template>
  <div class="row align-center candidaturas_alojamento">
    <div class="small-12 medium-10 large-9 columns alojamentolist">
      <HomeSectionTitle class="xpto" title="Candidaturas Alojamento" />
      <div class="row">
        <CandidaturaType 
          :concurso="concurso"
          :key="concurso.ID"
          v-for="concurso in concursos" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { ref } from "vue";
import { i18n } from "@/main.js";
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import CandidaturaType from "@/components/candidaturatype.vue";

export default {
  components: {
    HomeSectionTitle,
    CandidaturaType
  },
  setup() {

    const lang = i18n.global.locale;
    const concursos = ref([]);

    const formatDate = dateStr => {
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(date);
    };

    const today = new Date();
    const isDatePast = dateStr => {
      const date = new Date(dateStr);
      return today > date;
    };

    const getConcursos = () => {
      axios.get("/sas/alojamento/concursos").
        then(response => {
          concursos.value = response.data.map(el => {
            if (el.Fases.length > 0) {
              el.Fases = el.Fases.map(fase => {
                return {
                  ...fase,
                  DataFim: formatDate(fase.DataFim),
                  DataInicio: formatDate(fase.DataInicio),
                  isOpen: !isDatePast(fase.DataFim)
                }
              })
            }
            return {
              ...el,
              DataFim: formatDate(el.DataFim),
              DataInicio: formatDate(el.DataInicio),
              isOpen: !isDatePast(el.DataFim)
            }
          });
        }).catch(error => {
          console.log(error);
        })
    }

    getConcursos()

    /*axios.get("/sas/alojamento/tiposconcursos").
      then(response => {
        concursos.value = response.data;
        console.log(response.data);
      }).
      catch(error => {
        console.log(error);
      })*/




    return {
      concursos
    }
  }
}
</script>

<style lang="scss" scoped>
.candidaturas_alojamento {
  background-color: #f0f0f3;
}

.alojamentolist {
  padding-top: 0px;
  padding-bottom: 60px;
  padding-left: 50px;
}


@media (max-width: 1500px) and (min-width: 1370px) {
  .alojamentolist {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 1370px) and (min-width: 1000px) {
  .alojamentolist {
    max-width: 90%;
    flex: 0 0 90%;
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 767px) {
  .alojamentolist {
    padding-left: .625rem;
  }
}
</style>